import { useMemo } from 'react';

import { FieldSelect } from '@/components/looker/field-select';
import { ListUsers } from '@/task-manager/api/queries/list-users';
import type { TaskUser } from '@/task-manager/entities/task-user';

export type AssigneeFilterProps = {
  // Assignee email
  value?: string;
  onChange: (value?: string) => void;
};

export function AssigneeFilter({ value, onChange }: AssigneeFilterProps) {
  const listUsers = ListUsers.useQuery();

  const selectedAssignee = useMemo<TaskUser | undefined>(
    () =>
      listUsers.data?.users.find((user) => user.email === value) ?? undefined,
    [value, listUsers.data],
  );

  return (
    <FieldSelect
      data-testid="assignee-filter"
      label="Assignee"
      placeholder="Filter by assignee"
      value={selectedAssignee?.name}
      isClearable={true}
      isFilterable={true}
      options={
        listUsers.data?.users?.map((user) => ({
          label: user.name,
          value: user.email,
        })) ?? []
      }
      onChange={(email) => onChange(email)}
    />
  );
}
